import { Component, OnInit } from "@angular/core";
import { TreinFormService } from "../services/trein-form.service";
import { Router } from "@angular/router";
import { OLMapService } from "src/app/services/ol-map/ol-map.service";
import TileLayer from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";
import { TreinMapService } from "../services/trein-map.service";
import { AtlasFilterBaseComponent } from "src/app/components/ol-map/ol-map-filters/atlas-filter-base.component";
import { DatasetEntry } from "src/app/models/dataset-entry";
import { TREIN_FILTER_LABELS, TREIN_OPTIONS } from "src/assets/constants/constants";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import { faTimes as falTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faFilter as falFilter } from "@fortawesome/free-solid-svg-icons/faFilter";
import { faSpinner as falSpinnerThird } from "@fortawesome/free-solid-svg-icons/faSpinner";

@Component({
  selector: "app-atlas-trein-filter",
  templateUrl: "./atlas-trein-filter.component.html",
  styleUrls: ["./atlas-trein-filter.component.scss"],
})
export class AtlasTreinFilterComponent
  extends AtlasFilterBaseComponent
  implements OnInit
{
  get form() {
    return this.formService.form;
  }
  public parameters: any;
  readonly icons = {
    falTimes,
    falSpinnerThird,
    falFilter,
  };
  public readonly options = TREIN_OPTIONS;
  public formLabels = TREIN_FILTER_LABELS
  constructor(
    private formService: TreinFormService,
    private readonly router: Router,
    public readonly olMapService: OLMapService,
    private readonly treinMapService: TreinMapService,
  ) {
    super();
  }
  ngOnInit() : void{
    this.form.valueChanges.subscribe((value) => {
      this.updateRoute(value);
    })
  }
  updateRoute(value: any) {
    this.router.navigate([], {
      queryParamsHandling: "merge",
      queryParams: value,
    });
    const tileLayers = this.olMapService.map
      .getLayers()
      .getArray()
      .filter(
        (l) =>
          l instanceof TileLayer &&
          l.getSource() instanceof TileWMS &&
          l.getVisible()
      ) as TileLayer<TileWMS>[];
    const imageLayers = this.olMapService.map
      .getLayers()
      .getArray()
      .filter(
        (l) =>
          l instanceof ImageLayer &&
          l.getSource() instanceof ImageWMS &&
          l.getVisible()
      ) as ImageLayer<ImageWMS>[];
    this.olMapService.map.removeLayer(tileLayers[0]);
    imageLayers.forEach((l) => {
      this.olMapService.map.removeLayer(l);
    })
    this.treinMapService.loadLayer();
    this.olMapService.map.render();
  }
  setFilter(filter: string, value: any) {}
  changeDataset(entry: DatasetEntry) {}
}
